import React, { useCallback } from 'react'
import AspectRatio from 'react-aspect-ratio'

const RenderMedia = ({ item, currentIndex }) => {

    const RatioImage = useCallback((item) => {
        const itemSrc = item.original
        return (
            <AspectRatio ratio="1" style={{ maxWidth: '1080px' }}>
                <img itemProp="image" src={itemSrc} alt="" />
            </AspectRatio>
        )
    }, [])

    const RatioVideo = useCallback((item) => {
        const urlArray = item.original.split('/').filter((x) => x !== '')
        const fullVideoUrl = `${urlArray[0]}//player.${urlArray[1]}/video/${urlArray[2]}`
        const itemSrc = `${fullVideoUrl}?autoplay=1&loop=1&autopause=0&muted=1&logo=0&title=0`

        return (
            <AspectRatio ratio="1" style={{ maxWidth: '1080px' }}>
                <iframe
                    title="vimeo-player"
                    src={itemSrc}
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    loop="1"
                    allow="autoplay; fullscreen"
                    allowFullScreen
                    itemProp="image"
                />
                {/* Used to swipe video */}
                <div
                    style={{
                        height: '80%',
                        position: 'absolute',
                        top: '0px',
                        width: '35%',
                    }}
                ></div>
                <div
                    style={{
                        height: '60%',
                        position: 'absolute',
                        top: '80px',
                        width: '35%',
                        right: '0px',
                    }}
                ></div>
            </AspectRatio>
        )
    }, [])

    const VideoPlaceholder = () => {
        return (
            <AspectRatio ratio="1" style={{ maxWidth: '1080px' }}>
                <div
                    className="image-missing"
                    style={{
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                    }}
                ></div>
            </AspectRatio>
        )
    }

    if (item.type === 'img') {
        return RatioImage(item)
    } else if (item.type === 'video' && item.index === currentIndex) {
        return RatioVideo(item)
    } else {
        return VideoPlaceholder()
    }
}

export default RenderMedia
